import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductDetailsRoutingModule } from './product-details-routing.module';
import { ProductConfigurationComponent } from './product-configuration/product-configuration.component';
import { ProductSidebarComponent } from './product-sidebar/product-sidebar.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProductIngredientsComponent } from './product-ingredients/product-ingredients.component';
import { LetModule, PushModule } from '@ngrx/component';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { NgOptionHighlightModule } from '@ng-select/ng-option-highlight';
import { NgSelectModule } from '@ng-select/ng-select';
import { SharedModule } from '@piqet-angular/shared';
import { UiModule } from '@piqet-angular/ui';
import { NgChartsModule } from 'ng2-charts';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ProductManufactureComponent } from './product-manufacture/product-manufacture.component';
import { ProductEOLComponent } from './product-eol/product-eol.component';
import { ProductUseComponent } from './product-use/product-use.component';
import { ProductListComponent } from './product-list/product-list.component';
import { ProductChartAtGlanceComponent } from './product-chart-at-glance/product-chart-at-glance.component';
import { ProductReportGenerationComponent } from './product-report-generation/product-report-generation.component';
import { ProductDetailContentComponent } from './product-detail-content/product-detail-content.component';

@NgModule({
  declarations: [
    ProductConfigurationComponent,
    ProductSidebarComponent,
    ProductIngredientsComponent,
    ProductManufactureComponent,
    ProductEOLComponent,
    ProductUseComponent,
    ProductListComponent,
    ProductChartAtGlanceComponent,
    ProductReportGenerationComponent,
    ProductDetailContentComponent,
  ],
  imports: [
    CommonModule,
    ProductDetailsRoutingModule,
    LetModule,
    PushModule,
    NgSelectModule,
    UiModule,
    SharedModule,
    NgOptionHighlightModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSliderModule,
    NgxSpinnerModule,
    NgChartsModule,
    FormsModule,
  ],
  exports: [
    ProductSidebarComponent,
    ProductConfigurationComponent,
    ProductIngredientsComponent,
    ProductManufactureComponent,
    ProductDetailContentComponent,
    FormsModule,
    ReactiveFormsModule,
  ],
})
export class ProductDetailsModule {}
